import { defineStore } from "pinia";
import {
  getAllCompanyMembers,
  removeCompanyMember,
  updateCompanyMember,
} from "~/model/api/pLCnextStoreFrontendAPI";
import { withErrorHandling } from "~/helpers/withErrorHandling";
import { withErrorMessage } from "~/helpers/withErrorMessage";
import { withLoading } from "~/helpers/withLoading";
import type {
  WebModelGetCompanyMember,
  WebModelPutUpdateCompanyMember,
} from "~/model/api/pLCnextStoreFrontendAPI.schemas";
import { useUserStore } from "~/stores/userstore";

interface State {
  companyMembers: WebModelGetCompanyMember[];
}

export const useCompanyMembersStore = defineStore("companyMembers", {
  // convert to a function
  state: (): State => ({
    companyMembers: [], // initial state
  }),
  getters: {},
  actions: {
    async loadAllCompanyMembers(companyId: string) {
      const { data, error } = await withErrorHandling(
        withErrorMessage(withLoading(getAllCompanyMembers(companyId))),
      );
      console.debug("loadAllCompanyMembers: ", data, error);
      if (data) {
        this.companyMembers = data;
      }
    },

    async removeMemberFromCompany(companyId: string, userId: string) {
      if (!companyId || !userId) {
        return;
      }
      const { data, error } = await withErrorHandling(
        withErrorMessage(withLoading(removeCompanyMember(companyId, userId))),
      );
      console.debug("removeMemberFromCompany: ", data, error);
      await this.loadAllCompanyMembers(companyId);
    },

    async editMemberCompany(
      companyId: string,
      userId: string,
      webModelPutUpdateCompanyMember: WebModelPutUpdateCompanyMember,
    ) {
      if (!companyId || !userId) {
        return;
      }
      const { data } = await withErrorMessage(
        withLoading(
          updateCompanyMember(
            companyId,
            userId,
            webModelPutUpdateCompanyMember,
          ),
        ),
      );
      console.debug("editMemberCompany: ", data);

      // if user edited his own role -> reload userroles
      if (userId === useUserStore().authUser?.uuid) {
        await useUserStore().loadAuthUserRoles();
      }

      await this.loadAllCompanyMembers(companyId);
    },

    // easily reset state using `$reset`
    clear() {
      this.$reset();
    },
  },
});
